import { useContext } from 'react';
import { AuthContext } from '@/app/common/context/AuthContext.tsx';

export function useAuth() {
  return useContext(AuthContext);
}
